import { Button, Progress, User } from "@nextui-org/react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IconExclamationCircle } from "@tabler/icons-react";
import { useSearchParams } from "react-router-dom";
import { account } from "@pinnacle/api";
import { Transition } from "@headlessui/react";
import { useUserStore } from "@pinnacle/store/user";
import { useCountDown } from "ahooks";

export default function LoginCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { search } = useLocation();

  const [checkStep, setCheckStep] = useState<
    "init" | "checking" | "success" | "error"
  >("init");
  const [err, setError] = useState<string>("");
  const [backDate, setBackDate] = useState<number>();
  const [countdown] = useCountDown({
    targetDate: backDate,
  });

  const user = useUserStore((state) => state.user);

  const handleCallback = async () => {
    if (checkStep !== "init") return;

    setCheckStep("checking");
    // wait 3s using promise
    await new Promise((resolve) => setTimeout(resolve, 3000));
    setError("");

    const ticket = searchParams.get("ticket");
    const state = searchParams.get("state");
    const code = searchParams.get("code");
    const from = searchParams.get("from") || "/";

    try {
      const loginResult = await account.thirdLoginCallback({
        ticket,
        state,
        code,
        callback: window.location.origin + "/login/callback",
      });
      useUserStore.getState().setAuth(loginResult.data);
      await useUserStore.getState().refreshLoginStatus(true);
    } catch (e: any) {
      setError(e.message || e);
      setCheckStep("error");
      return;
    }
    setCheckStep("success");
    setBackDate(Date.now() + 5000);
    setTimeout(() => {
      navigate(from, { replace: true });
    }, 5000);
  };
  useEffect(() => {
    handleCallback();
  }, []);

  return (
    <div className="max-w-full w-[340px] border-3 border-default-500 rounded-medium py-6 px-4 mb-6 ">
      <Transition
        appear={true}
        show={checkStep === "checking"}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className=" flex flex-col  gap-6">
          <Progress
            size="lg"
            isIndeterminate
            label="验证第三方信息中，请稍后"
          />
        </div>
      </Transition>
      <Transition
        show={checkStep === "success" && !!user}
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className=" flex flex-col  gap-6">
          <User
            name={user?.nick_name || "未知用户"}
            description={user?.signature || "这个人很懒，什么都没留下"}
            avatarProps={{
              src: user?.avatar,
              name: (user?.nick_name || "未知用户").slice(0, 1),
            }}
          />
          👏 欢迎回来，将在{Math.floor(countdown / 1000)}秒后为你跳转回原页面
          <Button
            color="primary"
            onClick={() => {
              navigate(searchParams.get("from") || "/", { replace: true });
            }}
          >
            立即前往
          </Button>
        </div>
      </Transition>
      <Transition
        show={!!err}
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="text-center flex flex-col items-center justify-center gap-6">
          <IconExclamationCircle size="64px" />
          <div>第三方服务验证失败：{err}</div>
          <Button
            color="primary"
            onClick={() => {
              navigate("/login/phone" + search, { replace: true });
            }}
          >
            返回重试
          </Button>
        </div>
      </Transition>
    </div>
  );
}
